import "./AddressModal.css";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import { useDispatch } from "react-redux";
import {
  changeAddLine2,
  changeAddLine3,
  changeAddLine4,
  changeAddLine5,
  changeCity,
  changeCompanyName,
  changeCountryCode,
  changeSelectedState,
  changeStreetAddress,
  changeZipCode,
} from "../../../redux/Slices/PostMailSlice";
import { useState } from "react";
import { glassboxPopUpEvent } from "../../../core/components/Glassbox/Glassbox";

const AddressModal = ({
  verifiedAddress,
  showAVSLoader,
  cmsLabels,
  postMail,
  modal,
  setAfterVerification,
}) => {
  const dispatch = useDispatch();

  const [selectedVerifiedAddr, setSelectedVerifiedAddr] = useState(null);

  const changeToVerifiedAddress = (item) => {
    //console.log(item);

    if (item.coName !== null) dispatch(changeCompanyName(item.coName));

    if (item.country !== null) dispatch(changeCountryCode(item.country));

    if (item.state !== null) dispatch(changeSelectedState(item.state));

    if (item.addrLines[0] && item.addrLines[0] !== null)
      dispatch(changeStreetAddress(item.addrLines[0]));

    if (item.addrLines[1] && item.addrLines[1] !== null)
      dispatch(changeAddLine2(item.addrLines[1]));
    if (item.addrLines[2] && item.addrLines[2] !== null)
      dispatch(changeAddLine3(item.addrLines[2]));
    if (item.addrLines[3] && item.addrLines[3] !== null)
      dispatch(changeAddLine4(item.addrLines[3]));
    if (item.addrLines[4] && item.addrLines[4] !== null)
      dispatch(changeAddLine5(item.addrLines[4]));

    if (item.city !== null) dispatch(changeCity(item.city));
    if (item.postalCode !== null) dispatch(changeZipCode(item.postalCode));

    setAfterVerification(true);
  };

  return (
    <>
      <div
        id="postmodal"
        role="dialog"
        data-dds="modal"
        className="dds__modal dds__modal--lg"
        aria-labelledby="dds__modal-title"
      >
        <div className="dds__modal__content" style={{ margin: "3rem auto" }}>
          <div className="dds__modal__header dds__border">
            <h3 className="dds__modal__title" id="dds__modal-title1">
              {cmsParser(cms.address_suggestions, cmsLabels)}
            </h3>
          </div>

          <div className="dds__modal__body">
            {showAVSLoader ? (
              <div className="loader">
                <div className="square"></div>
                <div className="square"></div>
                <div className="square clear"></div>
                <div className="square"></div>
              </div>
            ) : null}
            <fieldset
              required={true}
              className="dds__fieldset dds__fieldset--lg"
            >
              <legend>{cmsParser(cms.verified_address, cmsLabels)}</legend>

              {verifiedAddress?.verificationStatus === "N" ? (
                <div className="dds__message-bar--warning dds__align-items-center dds__mt-4 dds__p-3">
                  <i
                    class="dds__icon dds__message-bar__icon dds__icon--alert-notice"
                    aria-hidden="true"
                  ></i>
                  {cmsParser(cms.address_suggestion_not_found, cmsLabels)}
                </div>
              ) : (
                verifiedAddress?.suggestions?.map((item, i) => (
                  <div
                    key={i}
                    className="dds__radio-button dds__radio-button--sm"
                  >
                    <input
                      className="dds__radio-button__input"
                      type="radio"
                      name="address"
                      id={"radio-button-input-" + i}
                      value={item?.suggestedValue}
                      onChange={() => setSelectedVerifiedAddr(item)}
                    />
                    <label
                      className="dds__radio-button__label"
                      htmlFor={"radio-button-input-" + i}
                    >
                      {item?.suggestedValue}
                    </label>
                  </div>
                ))
              )}

              <hr className="dds__divider" />
              <legend>{cmsParser(cms.your_entry, cmsLabels)}</legend>
              <div className="dds__radio-button dds__radio-button--sm">
                <input
                  className="dds__radio-button__input"
                  checked={!selectedVerifiedAddr}
                  type="radio"
                  name="address"
                  id={"radio-button-input-abc"}
                  onChange={() => setSelectedVerifiedAddr(null)}
                />
                <label
                  className="dds__radio-button__label"
                  htmlFor={"radio-button-input-abc"}
                >
                  {postMail?.city +
                    " " +
                    postMail?.selectedState +
                    " " +
                    postMail?.zipCode}
                </label>
              </div>
            </fieldset>
          </div>

          <div className="dds__modal__footer dds__py-4 dds__border">
            <button
              type="button"
              className="dds__button dds__button--sm"
              id="btn_UseVerified"
              disabled={!selectedVerifiedAddr}
              onClick={() => {
                changeToVerifiedAddress(selectedVerifiedAddr);
                modal.close();
                glassboxPopUpEvent("Closed_Change");
              }}
            >
              {cmsParser(cms.use_this_address, cmsLabels)}
            </button>

            <button
              type="button"
              disabled={selectedVerifiedAddr}
              onClick={() => {
                modal.close();
                glassboxPopUpEvent("Closed_Original");
                setAfterVerification(true);
              }}
              className="dds__button dds__button--sm"
              id="btn_UseOriginal"
            >
              {cmsParser(cms.use_original_address, cmsLabels)}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressModal;
